
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'treeMenu',
components: { Swipeout, SwipeoutItem, SwipeoutButton, Flexbox, FlexboxItem, XButton, LoadMore, Toast, Group, XSwitch },
props: {
listData: {
type: Array
},
searchConditionMap: {
type: Map,
default: null
}
},
directives: {
TransferDom
},
data () {
return {
$vue: '',
doctorId: '',
isTrue: 'list-item',
isFalse: '',
isOpen: false,
caseId: this.$route.params.caseid,
listName: '',
listUrl: '',
listNum: '',
caseList: [],
collectionList: [],
caseListType: '',
clickIndex: '',
isRefreshing: false,
isShowLoadMore: false,
loadMoreTip: '点击加载更多',
pageNum: 1, // 第几页参数
pageSize: 10, // 每次加载显示个数
isHasNextPage: true, // 是否存在下一页更多数据
firstText: '',
firstClass: '',
canClickFirst: false,
secondText: '',
secondClass: '',
canClickSecond: false,
firstFn: '',
secondFn: '',
openSecondBtnIndex: '',
disabledSwipeOut: true, // 暂时屏蔽右滑退回
showPositionValue: false
}
},
beforeMount () {
this.doctorId = localStorage.getItem('ID')
this.listName = this.listData.listName
this.listUrl = this.listData.url
this.caseListType = this.listData.caseListType

if (this.listData.isOpen !== undefined) {
this.isOpen = this.listData.isOpen
}

if (this.caseListType === 'cz') {
this.disabledSwipeOut = false
}

this.getCaseList(this.listUrl)

this.$vue = this
},
methods: {

showPosition () {
this.showPositionValue = true
},

toggleCaseList () {
this.isOpen = !this.isOpen
},

async openListAndSetPage () {
this.pageNum = parseInt(localStorage.getItem('pageNum'))

let params = new URLSearchParams()
params.append('pageSize', (this.pageSize * this.pageNum).toString())
params.append('pageNum', '1')
let success = await this.$http.post(this.listUrl, params)
if (success.data.result === '1') {

this.caseList = []

this.handlerCaseList(success.data.data)
}
this.isOpen = true

if (this.pageNum > 1) {

this.$emit('ScrollTo', this.pageNum)
}
},

async getCaseList () {
let params = new URLSearchParams()
params.append('pageSize', this.pageSize.toString())
params.append('pageNum', this.pageNum.toString())

if (this.searchConditionMap != null) {
params = this.handlerSearchParams(params)
}
try {
let success = await this.$http.post(this.listUrl, params)
if (success.data.result === '1') {

this.handlerCaseList(success.data.data)
}
} catch (e) {
console.log(e)
if (this.isRefreshing) {
this.isRefreshing = false
this.$emit('RefreshEvent', {result: '刷新失败'})
}
}
},

handlerCaseList (mydata) {

this.listNum = mydata.total

if (this.isRefreshing) {
this.isRefreshing = false
this.caseList = []
this.$emit('RefreshEvent', {result: '刷新成功'})
}

this.caseList = this.caseList.concat(mydata.list)

this.collectionList = []

for (let i = 0; i < this.caseList.length; i++) {

if (this.caseList[i].COLLECTION_STATE === 1) {
this.collectionList.push(this.caseList[i].CASE_ID)
}
}

this.isHasNextPage = mydata.hasNextPage
this.isShowLoadMore = false
if (this.isHasNextPage) {
this.loadMoreTip = '点击加载更多'
} else {
this.loadMoreTip = '没有更多数据了'
}
},

handlerSearchParams (urlParams) {
let patName = this.searchConditionMap.get('patName')
let patHology = this.searchConditionMap.get('patHology')
let startDate = this.searchConditionMap.get('startDate')
let endDate = this.searchConditionMap.get('endDate')
if (patName !== '' && patName !== undefined) {
urlParams.append('patName', patName)
}
if (patHology !== '' && patHology !== undefined) {
urlParams.append('patHology', patHology)
}
if (startDate !== '' && startDate !== undefined) {
urlParams.append('startDate', startDate)
}
if (endDate !== '' && endDate !== undefined) {
urlParams.append('endDate', endDate)
}
let typeArr = this.searchConditionMap.get('searchCaseType')

if (typeArr.indexOf('3') !== -1) {

let index = typeArr.indexOf('3')
typeArr.splice(index, 1)
urlParams.append('isQuick', '1')
}

urlParams.append('caseType', typeArr)
return urlParams
},

loadMore () {

if (this.isHasNextPage) {
this.isShowLoadMore = true
this.loadMoreTip = '正在加载中'
this.pageNum = this.pageNum + 1
this.getCaseList()
}
},

clickOn (caseItem, index) {

localStorage.setItem('pageNum', this.pageNum)
localStorage.setItem('listType', this.caseListType)


this.firstText = '推送给该医生'
this.firstClass = 'icon-auscultation'

this.firstFn = 'startMz'
this.canClickFirst = false

if (this.clickIndex === index) {
this.clickIndex = ''
} else {
this.clickIndex = index
}
},

refreshList () {

this.pageNum = 1
this.isRefreshing = true

this.getCaseList()

this.clickIndex = -1
},

async emitFirstEvent (poolId) {
let params = new URLSearchParams()
params.append('CASE_ID', this.caseId)
params.append('CASE_POOL_ID', poolId)
let suc = await this.$http.post(this.$vue.getData('ADD_UNION_CASE_DOC'), params)
if (suc.data.result === '1') {

this.$router.go(-1)
} else {

this.$router.go(-1)
}
},

emitSecondEvent (item) {
this.$emit('CaseEvent', {caseId: item.CASE_ID, event: this.secondFn})
},

invalidCase (id) {
this.$emit('CaseEvent', {caseId: id, event: 'invalidCase'})
},

collectCase (item) {
let params = new URLSearchParams()
params.append('CASE_ID', item.CASE_ID)
let index = this.collectionList.indexOf(item.CASE_ID)
if (index !== -1) {

this.$http.post(this.$vue.getData('DEL_CASE_COLLECTION'), params)

let index = this.collectionList.indexOf(item.CASE_ID)
this.collectionList.splice(index, 1)
} else {

this.$http.post(this.$vue.getData('ADD_CASE_COLLECTION'), params)
this.collectionList.push(item.CASE_ID)
this.showPositionValue = true
}

event.stopPropagation()
}
},
watch: {
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/caselist/list/medicalUnionPush.vue